import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 16px 1fr auto auto;
  grid-template-areas: 'image text status date';
  grid-column-gap: 0.5rem;
`;
